<template>
  <div class="w100 helper-page" style="background-repeat : no-repeat;background-size: 100%" :style="{ 'background-image': `url(${baseUrl}images/adviceBack.png)` }">
    <div class="helper-box bg-ww po-r card-shadow">
      <div class="robot po-a">
        <img :src="`${baseUrl}images/jiqir.png`" alt="">
      </div>

      <div class="helper-content flex-box">
        <div class="chart-box">
          <div class="message-box po-r" >
            <div class="message-c" id="message-c">
              <div class="flex-box ju-c mb10">
                <div class="chart-time">{{chartTime}}</div>
              </div>

              <div :class="`message flex-box ${item.type}`" v-for="(item, index) in messageList" :key="index">
                <div class="message-container po-r" @click="messageClick($event)">
                  <div v-html="item.content" class="msg"></div>

                  <div class="vote po-a" v-if="item.voteFlag && item.type === 'receive'">
                    <div class="up flex-box ju-c al-c" @click="submitVote(item, index, 'upVote')"><i class="iconfont icon-dianzan_up"></i></div>
                    <div class="down flex-box ju-c al-c" @click="submitVote(item, index, 'downVote')"><i class="iconfont icon-dianzan_down"></i></div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="search-suggestion po-a pl10 pr10" v-if="suggestions.length && inputting">
              <div class="bor-b suggestion pt10 pb10 cu-p" v-for="item in suggestions" :key="item.id" @click="suggestionClick(item)" v-html="handleSuggestion(item.title)"></div>
            </div>
          </div>
          <div class="input-box pt10 pl10 pr10 pb10 po-r">
            <div class="textarea">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入问题"
                autofocus
                v-model="inputMessage"
                @input="chartInput"
                @blur="onBlur"
                @keydown.enter.native="sendMessgae"
              >
              </el-input>
            </div>
            <div class="po-a send-btn">
              <el-button 
                :type="inputMessage?'primary':''" 
                :disabled="!inputMessage" style="width: 78px; height:42px; font-size: 16px"
                @click="sendMessgae"
              >发送</el-button>
            </div>
          </div>
        </div>
        <div class="nav-box" >
          <div class="flex-box">
            <div :class="`w50 flex-box ju-c al-c tab-item ${activeTab==0?'active':''}`">
              <div class="cu-p" @click="tabClick(0)">热点问题</div>
            </div>
            <div :class="`w50 flex-box ju-c al-c tab-item ${activeTab==1?'active':''}`">
              <div class="cu-p" @click="tabClick(1)">问题导航</div>
            </div>
          </div>

          <div v-if="activeTab==0" class="pl10 pr10 pt10 pb10 hot-comp" v-loading="navLoading1">
            <div v-for="item in hotList" class="bor-b flex-box al-c ju-sb hot-item pr10" :key="item.id">
              <div class=" font-14 cu-p hot-title mr10" @click="hotQuestionClick(item)">{{item.title}}<img :src="`${baseUrl}images/fire.png`" class="ml10"/></div>
              <div class="flex-box ju-c al-c"><img :src="`${baseUrl}images/forward.png`" alt="" class="cu-p" @click="hotQuestionClick(item)"></div>
            </div>

            <div class="flex-box hot-change ju-c pt20 pb10" v-if="hotList.length">
              <div class="flex-box al-c cu-p" @click="changeHotList">
                <i class="el-icon-refresh-right"></i>
                <div class="ml5" >换一批</div>
              </div>
            </div>

            <div class="grey tx-c" style="padding-top: 100px" v-if="!hotList.length">暂无热点问题</div>
          </div>

          <div v-else class="pl10 pr10 pt10 pb10 hot-comp po-r" v-loading="navLoading2">
            <div v-for="item in questionGroupList" class="bor-b flex-box al-c ju-sb hot-item cu-p pr10" :key="item.id" @click="navClick(item)" v-show="!drawer">
              <div class=" font-14 hot-title mr10" >{{item.name}}</div>
              <div class="flex-box ju-c al-c"><i class="el-icon-arrow-right"></i></div>
            </div>

            <el-drawer
              :visible.sync="drawer"
              direction="rtl"
              :with-header="false"
              :wrapperClosable="false"
              :modal="false"
              style="position: absolute"
              z-index="1"
            >
              <div class="drawer-title-box pr10 pl10">
                <div class="drawer-title pl10">
                  <i class="el-icon-arrow-left mr10 cu-p" @click="drawer = false"></i>
                  <span>{{clickNav.name}}</span>
                </div>
              </div>
              <div v-loading="drawerLoading">
                <div v-for="item in navQusList" class="bor-b flex-box al-c ju-sb hot-item pr10" :key="item.id">
                  <div class=" font-14 cu-p hot-title mr10" @click="hotQuestionClick(item)">{{item.title}}</div>
                  <div class="flex-box ju-c al-c"><img :src="`${baseUrl}images/forward.png`" alt="" class="cu-p" @click="hotQuestionClick(item)"></div>
                </div>
                <div class="grey tx-c" style="padding-top: 100px" v-if="!navQusList.length">暂无问题</div>
              </div>
            </el-drawer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {questionList, questionViews, questionHotList, questionGroupList, upVote, downVote} from '@/api/management/QAHelper'
import {_debounce} from '@/util/utils'

export default {
  name: "QAHelper",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      messageList: [],
      inputMessage: '',
      handleInputMessage: '',
      questionList: [],
      activeTab: 0,
      hotListPage: {
        current: 1,
        size: 5,
        total: 0,
        pages: 1,
      },
      hotList: [],
      questionGroupList: [],
      navQusList: [],
      navLoading1: false,
      navLoading2: false,
      drawer: false,
      drawerLoading: false,
      clickNav: {},
      suggestions: [],
      inputting: false,
      searching: false,
    };
  },
  components: {
  },
  computed: {
    chartTime(){
      const now = new Date()
      let minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
      let hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
      let week = '';
      switch (now.getDay()) {
        case 0:
          week = '星期天'
          break;
        case 1:
          week = '星期一'
          break;
        case 2:
          week = '星期二'
          break;
        case 3:
          week = '星期三'
          break;
        case 4:
          week = '星期四'
          break;
        case 5:
          week = '星期五'
          break;
        case 6:
          week = '星期六'
          break;
      }
      return `${now.getMonth() + 1}月${now.getDate()}日 ${hours}:${minutes} ${week}`
    }
  },
  filters: {
  },
  watch: {
    inputMessage(){
      this.suggestions = []
    }
  },
  created() {
    setTimeout(() => {
      this.pushMessage('receive','您可以输入问题关键词进行提问')
    }, 1000);

    this.initHotList()
  },
  methods: {
    chartInput: _debounce(function() {
      if(!this.inputMessage){
        return
      }
      this.inputting = true;
      questionList({current:1, size: 3, keywords: this.inputMessage})
      .then(({data}) => {
        if(data.code == 0){
          this.suggestions = data.data.records || []
        }else {
          this.$message.error(data.msg)
        }
      })
    },300),
    handleSuggestion(val){
      let str = this.inputMessage
      if(str.includes('?')){
        str = str.replace(/\?/g, '\\?')
      }
      if(str.includes('$')){
        str = str.replace(/\$/g, '\\$')
      }
      if(str.includes('*')){
        str = str.replace(/\*/g, '\\*')
      }
      if(str.includes('+')){
        str = str.replace(/\+/g, '\\+')
      }
      if(str.includes('.')){
        str = str.replace(/\./g, '\\.')
      }
      return val.replace(new RegExp(str, 'g'), `<span style="color: #5A8FFD">${this.inputMessage}</span>`)
    },
    suggestionClick(item){
      this.inputMessage = '';
      this.handleSearchAnswer(item.title, item.id)
    },
    onBlur(){
      setTimeout(() => {
        this.inputting = false
      }, 250);
    },
    sendMessgae(event){
      event.preventDefault()
      if(!this.inputMessage || this.searching){
        return
      }
      this.inputting = false;
      this.pushMessage('send',this.inputMessage)
      let keywords = this.inputMessage
      this.inputMessage = '';

      this.searching = true

      this.pushMessage('receive','搜索中...')

      this.$nextTick(() => {
        this.scrollBottom()
      })

      questionList({current:1, size: 20, keywords: keywords})
      .then(({data}) => {
        if(data.code == 0){
          this.questionList = data.data.records || [];

          this.messageList.pop()

          if(this.questionList.length){
            // let htmlStr = `<h4>您想了解什么"${keywords}"信息?</h4>`
            let htmlStr = `<h4>您是想问?</h4>`
            this.questionList.forEach(item => {
              htmlStr += `<p><a qId="${item.id}">${item.title}</a></p>`
            })
            this.pushMessage('receive',htmlStr)
          }else {
            this.giveHotQustion()
          }

          this.$nextTick(() => {
            this.scrollBottom()
          })
          
        }else {
          this.messageList.pop()
          this.pushMessage('receive','服务异常,请稍后重试')
        }
      }).catch(() => {
        this.messageList.pop()
        this.pushMessage('receive','服务异常,请稍后重试')
      }).finally(() => {
        this.searching = false
      })
    },
    giveHotQustion(){
      this.searching = true
      this.pushMessage('receive','搜索中...')

      this.$nextTick(() => {
        this.scrollBottom()
      })
      let obj = {
        current: 1,
        size: 5,
      }
      questionHotList(obj)
      .then(({data}) => {
        this.messageList.pop()
        if(data.code == 0){
          if(data.data.records.length){
            let htmlStr = `<h4>智能问答助手猜您想问：</h4>`;
            data.data.records.forEach(item => {
              htmlStr += `<p><a qId="${item.id}">${item.title}</a></p>`
            })
            this.pushMessage('receive',htmlStr)
          }else {
            this.pushMessage('receive','没有找到答案')
          }
        }else {
          this.pushMessage('receive','服务异常,请稍后重试')
        }
        this.$nextTick(() => {
          this.scrollBottom()
        })
      }).catch(() => {
        this.messageList.pop()
        this.pushMessage('receive','服务异常,请稍后重试')
      }).finally(() => {
        this.searching = false
      })
    },
    pushMessage(type, content, id, voteFlag){
      this.messageList.push({
        content,
        type,
        voteFlag,
        id,
      })
    },
    messageClick(event){
      if(this.searching){
        return
      }
      if(event.target.nodeName === 'A'){
        const htmlStr = event.target.innerHTML
        const id = event.target.getAttribute('qId')
        this.handleSearchAnswer(htmlStr, id)
      }
    },
    hotQuestionClick(item){
      if(this.searching){
        return
      }
      this.handleSearchAnswer(item.title, item.id)
    },
    handleSearchAnswer(htmlStr, id){
      this.pushMessage('send', htmlStr)
      this.searching = true
      this.pushMessage('receive', '搜索中...')

      this.$nextTick(() => {
        this.scrollBottom()
      })

      questionViews({questionId:id})
      .then(({data}) => {
        this.messageList.pop()
        if(data.code == 0){
          this.pushMessage('receive', data.data.content, data.data.id, true)
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }else {
          this.messageList.pop()
          this.pushMessage('receive','服务异常,请稍后重试')
        }
      }).catch(() => {
        this.messageList.pop()
        this.pushMessage('receive','服务异常,请稍后重试')
      }).finally(() => {
        this.searching = false
      })
    },
    scrollBottom(){
      var ele = document.getElementById('message-c');
      ele.scrollTop = ele.scrollHeight;
    },
    tabClick(index){
      this.activeTab = index;
      if(index == 0){
        this.initHotList()
        this.drawer = false;
      }else {
        this.getQuestionGroupList()
      }
    },
    initHotList(){
      this.hotListPage.current = 1;
      this.getHotList()
    },
    getHotList(){
      let obj = {
        current: this.hotListPage.current,
        size: this.hotListPage.size,
      }
      this.navLoading1 = true;
      questionHotList(obj)
      .then(({data}) => {
        if(data.code == 0){
          this.hotList = data.data.records || []
          this.hotListPage.total = data.data.total;
          this.hotListPage.pages = data.data.pages;
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        setTimeout(() => {
          this.navLoading1 = false;
        }, 500);
      })
    },
    changeHotList(){
      this.hotListPage.current += 1;
      if(this.hotListPage.current>this.hotListPage.pages){
        this.hotListPage.current = 1;
      }
      this.getHotList()
    },
    getQuestionGroupList(){
      this.navLoading2 = true;
      questionGroupList({current:1, size: 100})
      .then(({data}) => {
        if(data.code == 0){
          this.questionGroupList = data.data.records || []
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        setTimeout(() => {
          this.navLoading2 = false;
        }, 500);
      })
    },
    navClick(item){
      this.clickNav = item;
      this.drawerLoading = true
      questionList({current:1, size: 100, groupId: item.id})
      .then(({data}) => {
        if(data.code == 0){
          this.navQusList = data.data.records || [];
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.drawerLoading = false
      })
      this.drawer = true;
    },
    submitVote(item, index, type){
      this.messageList[index].voteFlag = false;
      let rq;
      if(type==='upVote'){
        rq = upVote;
      }else {
        rq = downVote;
      }
      rq({questionId: item.id}).then(({data}) => {
        if(data.code == 0){
          this.$message.success('评价成功')
        }else {
          this.$message.error(data.msg)
          this.messageList[index].voteFlag = true;
        }
      }).catch(() => {
        this.messageList[index].voteFlag = true;
      })
    },
  }
};
</script>

<style lang="less" scoped>
.helper-page {
  padding-top: 1px;
  .drawer-title-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .drawer-title {
    background-color: #f3f3f3;
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
}
.helper-box{
  width: 1200px;
  height: 640px;
  border-radius: 10px;
  margin: 160px auto;
  padding-top: 100px;
  .robot {
    top: -63px;
    left: 537px;
    &::after {
      content: '智能问答助手';
      display: block;
      color: #292929;
      position: absolute;
      font-size: 18px;
      bottom: -18px;
      left: 11px;
      z-index: 1;
    }
  }
  .helper-content {
    border-top: 1px solid #EDF1F6;
    height: 100%;
    .chart-box {
      width: 795px;
      border-right: 2px solid #EDF1F6;
      .message-box {
        height: 423px;
        background-color: #EDF1F6;
        // padding: 16px;
        // padding-top: 20px;
        .message-c {
          height: 100%;
          overflow-y: auto;
          padding: 16px;
          padding-top: 20px;
        }
        .search-suggestion {
          width: 98%;
          background-color: #fff;
          bottom: 12px;
          left: 8px;
          border-radius: 6px;
          position: absolute;
        }
        .chart-time {
          line-height: 30px;
          font-size: 12px;
          background-color: #E1E5EB;
          color: #fff;
          text-align: center;
          padding: 0 8px;
          border-radius: 6px;
        }
        .message {
          padding: 10px 0;
          &:hover .message-container .vote {
            display: block;
          }
          .message-container {
            padding: 10px 16px;
            background-color: #fff;
            max-width: 400px;
            line-height: 24px;
            .vote {
              display: none;
              top: 50%;
              right: -40px;
              margin-top: -33px;
              .up,.down {
                height: 30px;
                width: 30px;
                border-radius: 100%;
                background-color: #fff;
                color: #aaa;
                cursor: pointer;
                &:not(.up){
                  margin-top: 6px;
                }
              }
              .up:hover {
                color: #5A8FFD;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
              }
              .down:hover {
                color: #f75b47;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
              }
            }
            /deep/ a {
              color: #5A8FFD;
              &:hover {
                cursor: pointer;
                color: #ccc;
              }
            }
            /deep/ h4 {
              font-weight: normal;
              line-height: 30px;
              border-bottom: 1px solid #ccc;
              margin-bottom: 10px;
            }
            .msg {
              word-wrap: break-word;
            }
          }
          &.receive {
            .message-container {
              border-radius: 0px 10px 10px 10px;
            }
          }
          &.send {
            justify-content: flex-end;
            .message-container {
              border-radius: 10px 0px 10px 10px;
              color: #fff;
              background-color: #5A8FFD;
            }
          }
        }
      }
      .input-box {
        height: 117px;
        .send-btn {
          right: 32px;
          top: 40px;
        }
        .textarea {
          width: 85%;
          /deep/ .el-textarea .el-textarea__inner{ 
            resize: none;
            border: none;
          }
        }
      }
    }
    .nav-box {
      color: #3c3c3c;
      width: 405px;
      .tab-item {
        position: relative;
        height: 50px;
        &.active {
          color: #5A8FFD;
          &::after {
            content: '';
            position: absolute;
            width: 40px;
            height: 4px;
            background-color: #3D79FF;
            bottom: 0;
            left: 82px;
          }
        }
      }
      .hot-comp {
        overflow-y: auto;
        height: calc(100% - 50px);
        .hot-item {
          padding: 13px 10px;
          line-height: 24px;
          .hot-title {
            &:hover {
              color: #5A8FFD;
            }
          }
        }
        .hot-change {
          line-height: 1;
          color: #3D79FF;
          font-size: 16px;
        }
        /deep/ .el-drawer__wrapper .el-drawer__container .el-drawer {
          width: 100% !important;
          outline: none;
          .el-drawer__body {
            padding: 10px;
            overflow-y: auto;
            font-size: 14px;
            padding-top: 48px;
          }
        }
      }
    }
  }
}
</style>